enum LanguageTypeEnum  {
  English = 1,
  Swedish = 2,
}
export default Object.freeze(LanguageTypeEnum);
